import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container
} from "reactstrap";

import { useNavigate } from 'react-router-dom';

import "./TiltCardRow.css";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

const TiltCardRow = ({ cards, cardsPerRow, thumbnailUrls, themeName, collectionName }) => {
  const containerRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const [cardWidth, setCardWidth] = useState(16);
  useEffect(()=>{
    let newCardWidth = 16;
    if(cardsPerRow === 4){newCardWidth = 20;}
    if(cardsPerRow === 3){newCardWidth = 26;}
    if(cardsPerRow === 2){newCardWidth = 35;}
    if(cardsPerRow === 1){newCardWidth = 60;}

    setCardWidth(prev => newCardWidth);
  },[cardsPerRow])

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const placeholdersNeeded = cardsPerRow - cards.length;

  return (
    <div
      ref={containerRef}
      className="tilt-card-row"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {cards.map((cardData, i) => (
        <TiltCard key={i}
          mousePos={mousePos}
          containerRef={containerRef}
          index={i}
          isHovered={isHovered}
          cardData={cardData}
          cardWidth={cardWidth}
          isPlaceholder={false}
          thumbnailUrls={thumbnailUrls}
          themeName={themeName}
          collectionName={collectionName}
        />
      ))}
      {/* Pad with placeholders to keep layout consistent */}
      {
        Array.from({ length: placeholdersNeeded }).map((_, idx) => (
          <TiltCard
            key={idx}
            mousePos={mousePos}
            containerRef={containerRef}
            index={idx}
            isHovered={isHovered}
            cardData={{label:""}}
            cardWidth={cardWidth}
            isPlaceholder={true}
            thumbnailUrls={thumbnailUrls}
          />
        ))
      }
    </div>  
  );
};

const TiltCard = ({ 
  cardData, 
  mousePos, 
  containerRef, 
  index, 
  isHovered, 
  cardWidth, 
  isPlaceholder, 
  thumbnailUrls,
  themeName,
  collectionName
}) => {
  
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const [tilt, setTilt] = useState({ rotateX: 0, rotateY: 0 });
  const [isCardHovered, setIsCardHovered] = useState(false);

  const handleMouseLeave = () => {
    setIsCardHovered(false);
  };

  const handleMouseEnter = () => {
    setIsCardHovered(true);
  };

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const calcTilt = () => {
    if (!cardRef.current || !containerRef.current) return;

    const cardRect = cardRef.current.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();

    const relativeX = mousePos.x - (cardRect.left - containerRect.left + cardRect.width / 2);
    const relativeY = mousePos.y - (cardRect.top - containerRect.top + cardRect.height / 2);

    const rotateX = clamp((relativeY / cardRect.height) * -15, 0, 0); // invert Y
    //const rotateY = clamp((relativeX / cardRect.width) * 5, -12, 12);

    let rotateY;
    if(isCardHovered){
      rotateY = clamp((relativeX / cardRect.width) * 10, -20, 20);
    } else {
      rotateY = clamp((relativeX / cardRect.width) * 5, -30, 30);
    }

    setTilt({ rotateX, rotateY });
  };

  useEffect(() => {
    if (isHovered) {
      calcTilt();
    } else {
      setTilt({ rotateX: 0, rotateY: 0 }); // reset on exit
    }
  }, [mousePos, isHovered, isCardHovered]);

  const scaleParam = 1.05+(Math.abs(tilt.rotateY*5)-75)/1000;

  return (
    <div 
      style={{
        position: "relative",
        margin: "0px 15px",
        cursor: "pointer",
        visibility: !isPlaceholder ? "visible" : "hidden"
      }}
      onClick={()=>{
        navigate(`/myInfo/topics/${cardData._id}`, {
          state: { themeName: themeName, collectionName: collectionName, topicName: cardData.label }
        })
      }}
    >
      <div className="tilt-card-scale" 
        style={{ /*transform: `scale(${isCardHovered ? 1.05 : 1})`*/ }}
      >
        <div
          ref={cardRef}
          className="tilt-card"
          style={{
            transform: `rotateX(${tilt.rotateX}deg) rotateY(${tilt.rotateY}deg) scale(${scaleParam})`,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="tilt-card-image" 
            style={{
              background: `url(${thumbnailUrls[cardData._id] || placeholder_image}) center/cover no-repeat`,
              transition: `background 0.3s ease-in-out`,
            }}
          />
          {/*<div className="tilt-card-text">{scaleParam}</div>*/}
        </div>
      </div>
      <div className="tilt-card-label" 
        style={{
          position: "absolute",
          bottom: "0",
          marginBottom: `${isCardHovered ? 32.5 : 33.0-Math.abs(tilt.rotateY)*0.35}px`,
          /*left: `calc(90px - ${cardData.label.length*6.5}px)`,*/
          transform: `translateX(-50%) scale(${isCardHovered ? scaleParam : scaleParam}) translateY(${isCardHovered ? 0 : 0}px)`,
          transition: `transform 0.08s ease, margin 0s ease`,
          pointerEvents: 'none',
          willChange: 'margin',
          left: "50%",
        }}
      >
        <p className="mb-0">{cardData.label}</p>
      </div>
    </div>
  );
};

export default TiltCardRow;


